import React from 'react';
import { Trans } from '@lingui/react';

export default {
    noStudentsAvailable: <Trans>No students available</Trans>,
    selectAll: <Trans>Select All</Trans>
};



// WEBPACK FOOTER //
// ./components/available-students-filter/available-students-filter-text.js